import { render, staticRenderFns } from "./List.vue?vue&type=template&id=7d83d0ba&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d83d0ba')) {
      api.createRecord('7d83d0ba', component.options)
    } else {
      api.reload('7d83d0ba', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=7d83d0ba&", function () {
      api.rerender('7d83d0ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/vistas/emails/List.vue"
export default component.exports